export default __webpack_public_path__ + "static/13-a703378e3402dce105ce05efdcc166f4.png";